<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 减重小程序端-月报页面
-->

<template>
  <div class="page-main">
    <div v-if="showTip != -1" class="top-tip">
      长按分享或保存图片
    </div>
    <div class="report-dialog">
      <div v-if="!url" class="page-content" id="reportCon">
        <div class="title">{{ detailData.titleName }}</div>
        <div class="flex-1">
          <div class="desc-item">购货单位：{{ detailData.purchaseUnit }}</div>
          <div class="desc-item">销售日期：{{ detailData.saleDate }}</div>
          <div class="desc-item">仓库：{{ detailData.stock }}</div>
          <div class="desc-item">单据编号：{{ detailData.billNo }}</div>
        </div>
        <div class="flex-1">
          <div class="desc-item">收货人：{{ detailData.receiver }}</div>
          <div class="desc-item">联系方式：{{ detailData.contact }}</div>
          <div class="desc-item">备注：{{ detailData.remark }}</div>
        </div>
        <div class="flex-1">
          <div class="desc-item">收货地址：{{ detailData.address }}</div>
        </div>
        <table>
          <tr>
            <th width="90px">商品编号</th>
            <th>品名</th>
            <th width="100px">规格</th>
            <th width="100px">产品批号</th>
            <th width="120px">有效期</th>
            <th width="60px">单位</th>
            <th width="90px">数量</th>
            <th width="90px">单价/元</th>
            <th width="110px">含税金额/元</th>
          </tr>

          <tr v-for="(item, index) in productList" :key="index">
            <td>{{ item.code }}</td>
            <td>{{ item.productName }}</td>
            <td>{{ item.specify }}</td>
            <td>{{ item.batchNo }}</td>
            <td>{{ item.expireDate }}</td>
            <td>{{ item.unit }}</td>
            <td>{{ item.quantity }}</td>
            <td>{{ item.singlePrice }}</td>
            <td>{{ item.taxAmount }}</td>
          </tr>
         <tr> </tr>
          <tr>
            <td>合计</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>{{ totalData.totalNum }}</td>
            <td></td>
            <td>{{ totalData.totalTaxAmount }}</td>
          </tr>
        </table>
        <div class="flex-1">
          <div class="desc-item">经办人：{{ detailData.operator }}</div>
          <div class="desc-item">{{ detailData.operatorPhone }}</div>
        </div>
      </div>
    </div>
    <div v-if="url" class="img-box">
      <img :src="url" />
    </div>
    <div v-if="!url" class="loading"><img :src="loading" /></div>
  </div>
</template>

<script>
import ajax from '../../api/ajax';
import { getQueryString } from '../../api/restapi';
import { htmlToPDF } from "../../utils/html2pdf";
import loading from '../../assets/images/pending.gif'

export default {
  data() {
    return {
      loading,
      showTip:1,
      productList: [],
      detailData: {},
      url: '',
      totalData:{}
    };
  },
  mounted() {
    document.title = '出库单';
    this.id = getQueryString('id');
    this.getRecordInfo();
    this.showTip = getQueryString('showTip');
  },

  methods: {
    getRecordInfo() {
      ajax
        .Post({
          url: '/api/mall/u8c/selectu8cOutStockById',
          data: { id: this.id },
          timeout:20000,
        }).then(({ data: { success, data } }) => {
          if (success) {
            this.detailData = data.parent || {}
            this.productList = data.items || []
            let totalNum=data.items.reduce((total,item)=>total+item.quantity,0)
            let totalTaxAmount=data.items.reduce((total,item)=>total+item.taxAmount,0)
            this.totalData={
              totalNum,
              totalTaxAmount
            }
            setTimeout(() => {
              this.saveImg()
            }, 1500)
          } else {
            this.$message.error('数据请求失败')
          }
        })
    },

    saveImg() {

      htmlToPDF('reportCon', '出库单').then(url => {
        this.url = url
      });
    },
  },
};
</script>

<style scoped>
html {
  font-size: 12px;
}

div,
p,
ul,
li,
* {
  box-sizing: border-box;
  font-size: 14px;
}

.loading {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 99;
  height: 100%;
  /* background: rgba(0, 0, 0, .2); */
}

.loading img {
  width: 50px;
  height: 50px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.top-tip {
  width: 100%;
  height: 120px;
  line-height: 120px;
  color: crimson;
  font-size: 14px;
  text-align: center;
}

.page-main {
  padding: 10px;
}

.report-dialog {
  opacity: 0;
}

.page-content {
  width: 1000px;
  border: 1px solid #ccc;
  padding: 40px 30px;
  background-color: #fff;
}

.page-content .title {
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 15px;
}

.flex-1 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

table {
  width: 100%;
  margin-bottom: 10px;
  border-collapse: separate;
  border-spacing: 0;
  border-right: 1px solid #9B9EAD;
  border-bottom: 1px solid #9B9EAD;
}

th,
td {
  border: 1px solid #9B9EAD;
  padding: 5px 10px;
  text-align: center;
  border-right: none;
  border-bottom: none;
}

.img-box {
  width: 100%;
  padding: 10px;
}

.img-box img {
  width: 100%;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
  /* position:relative;
  top:1.33rem;
  left:1.33rem; */
}
</style>
